import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewInit,
  AfterContentInit,
  AfterViewChecked,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CarouselCard, ChatService, Message } from './chat.service';
import { Observable } from 'rxjs';
import { scan } from 'rxjs/operators';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToggleService } from './services/toggle.service';
import { FooterComponent } from './components/footer/footer.component';

declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewChecked {


  title = 'Chatbot';
  bigRobot = true;
  showEmoj = true;
  userForm = {
    email: null,
    name: null,
    phone: null,
  };

  showCarousal = false;
  scrollDown = false;
  currentBotMessageIndex = 0;
  starRatingModuleTriggerCount = 0;
  greet = '';
  numberKeypressOnly = false;
  constructor(
      private chat: ChatService,
      private route: ActivatedRoute,
      private cdr: ChangeDetectorRef,
      private formBuilder: FormBuilder,
      private readonly toggleService: ToggleService
  ) {}

  // @ViewChild("scrollElement", null) scroollProp: ElementRef;
  sessionId: any ;
  uploadedFile: File;
  messages: Observable<Message[]>;
  formValue = '';
  lastMsg: any = {
    sessionAttributes: {},
    showInput: true,
    sessionDetails: {},
  };
  types: string[] = [];
  sessionAttrib: any = {};
  sessionDetails: any = {};
  userId = 'user';
  showIndicator = false;
  uploadFile = File;
  userDetails = {};
  registerForm: FormGroup;
  submitted = false;
  count = 0;
  chatbotLang = 'en';
  sessionState: any = null;
  initialClick = false;
  scrollHeight = 0;
  scrollingIndex = 0;
  displayAttachmentIcon = false;
  carouselData: CarouselCard[] = [];
  
  ngOnInit(): void {
    this.sessionIdFn();
    this.chat.connectToServerByWebSocket();
    this.chat.startTypingInterval();

    $('#OpenImgUpload').click(() => {
      $('#imgupload').trigger('click');
    });

    this.sessionAttrib = {};
    this.chat.conversation
        .asObservable()
        .subscribe((data) => console.log(data));
    this.messages = this.chat.conversation.asObservable().pipe(
        scan((acc, val, i) => {
          console.log('acc', acc);
          console.log('val', val);
          let elementIndex = 0;
          for (let index = 0; index < acc.length; index++) {
            if (acc[index].sentBy === 'user' && acc[index].content) {
              elementIndex = index;
              break;
            }
          }
          let arr = [];
          if (val.length) {
            arr = val.concat(acc);
          } else {
            arr = val.concat([]);
          }

          for (let index = 0; index < arr.length; index++) {
            let nextIndex = index + 1;
            if (index !== arr.length - 1) {
              if (arr[nextIndex].content === 'image' || arr[nextIndex].content === 'table') {
                nextIndex += 1;
              }
              if ((arr[index].sentBy === 'bot' && arr[nextIndex].sentBy === 'bot') ||
                  (arr[index].sentBy === 'user' && arr[nextIndex].sentBy === 'user')) {
                arr[index].showImage = false;
              } else {
                arr[index].showImage = true;
              }
            } else {
              arr[index].showImage = true;
            }
          }

          if (!this.formValue) {
            setTimeout(() => {
              const container = $('#content');
              const scrollTo = $(`#message_${elementIndex + 1}`);
              console.log('test', container.offset(), 'scroll to:', scrollTo.offset(), 'container: ', container.scrollTop());

              if (scrollTo && container && scrollTo.offset() && container.offset()) {
                console.log('scroll is working', this.formValue);
                container.animate({
                  scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
                });
                console.log('test2', container.offset().top, 'scroll to:', scrollTo.offset().top, 'container: ', container.scrollTop());
              } else {
                container.animate({
                  scrollTop:  129.265625 - 559.25
                });
              }
            }, 1);
          }

          const carouselMessages = val.filter(m => m.sentBy === 'bot' && m.carouselData?.length);
          if (carouselMessages.length > 0) {
            this.carouselData = carouselMessages[0].carouselData;
            console.log("Carousel Data:", this.carouselData);
          }

          return arr;

        })
    );
    // this.sendMessage('Hi', null);

    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  sessionIdFn() {
    if (localStorage.getItem('sessionId')) {
      this.sessionId = localStorage.getItem('sessionId');
    } else {
      this.sessionId = (Math.floor(new Date().valueOf() * Math.random())).toString();
      localStorage.setItem('sessionId', this.sessionId);
    }

  }

  // ngAfterViewChecked() {
  //  $("#content").scrollTop($("#content")[0].scrollHeight);
  // }

  public ngAfterViewChecked(): void {
    const botBody = document.getElementById('content');
    // console.log(document.getElementById(`message_${this.scrollingIndex}`).scrollHeight);
    if (!this.initialClick) {
      const heightDifference = botBody.scrollHeight - this.scrollHeight;
      if (botBody.scrollTop < 0 && this.scrollHeight && botBody.scrollHeight !== this.scrollHeight && heightDifference > 200) {
        botBody.scrollTop = botBody.scrollHeight;
      } else if (botBody.scrollTop === 0 && this.scrollHeight && botBody.scrollHeight > this.scrollHeight && heightDifference > 200) {
        // document.getElementById(`message_${this.scrollingIndex}`).scrollIntoView();
        botBody.scrollTop = document.getElementById(`message_${this.scrollingIndex}`).offsetTop - 50;
      }
      if (heightDifference === 83 || !this.scrollHeight) {
        botBody.scrollTop = botBody.scrollHeight;
      }
      if (heightDifference > 500 && botBody.scrollTop === 1) {
        // document.getElementById(`message_${this.scrollingIndex}`).scrollIntoView();
        botBody.scrollTop = document.getElementById(`message_${this.scrollingIndex}`).offsetTop - 50;
      }
      if (heightDifference < 0) {
        botBody.scrollTop = document.getElementById(`message_${this.scrollingIndex}`).offsetTop - 75;
      }
      if (botBody.scrollHeight !== this.scrollHeight) {
        this.scrollHeight = botBody.scrollHeight;
      }
    }
  }



  get f() {
    return this.registerForm.controls;
  }

  fireInputEvent() {
    $('input[type=\'file\']').trigger('click');
  }

  inputValueChange(event) {
    this.formValue = event;
  }

  sendMessage(
      msg: any = null,
      divId: string = null,
      slotToElicit: string = null,
      image: any = null,
      showMsg: string = null,
      sessionAttributes: any = null,
      clickedButton: any = null
  ) {
    this.bigRobot = false;
    this.currentBotMessageIndex = - 1;
    console.log('msg: ', msg);
    console.log('this.formValue: ', this.formValue);
    //console.log('lastMsg', this.lastMsg);

    // // @ts-ignore
    this.count++;
    if (msg) {
      this.formValue = msg;
    }

    // get button value to send correct response
    // if user enter answer to input instead of using button
    // if (this.lastMsg.hasOwnProperty("messages")) {
    //   var responseCard = this.lastMsg.messages.filter(
    //       (ele) => ele["contentType"] == "ImageResponseCard"
    //   );
    //   console.log(
    //       "responsecard msg => ",
    //       JSON.stringify(responseCard)
    //   );
    //   let message = this.formValue;
    //   if (responseCard.length > 0) {
    //     var cards = responseCard[0].imageResponseCard;
    //     cards.buttons.forEach(function (btn, index) {
    //       if (message.trim().toLowerCase() === btn.text.toLowerCase()) {
    //         message = btn.value.trim();
    //       }
    //     });
    //   }
    //   showMsg = this.formValue;
    //   this.formValue = message;
    // }

    if (this.sessionDetails) {
      slotToElicit = this.sessionDetails.slotToElicit;
    }

    if (this.formValue) {
      this.showIndicator = true;
      if (
          this.userForm.email != null &&
          this.userForm.name != null &&
          this.userForm.phone != null
      ) {
        this.sessionDetails.sessionAttributes.formValue = this.userForm;
        this.userForm = {
          email: null,
          name: null,
          phone: null,
        };
      }
      this.sessionAttrib = sessionAttributes;
      console.log('sessionId', this.sessionId);
      this.chat
          .converse(
              this.formValue,
              this.sessionId,
              this.sessionState,
              this.userDetails,
              this.sessionDetails,
              this.sessionAttrib,
              slotToElicit,
              image,
              showMsg,
              clickedButton
          )
          .then((data) => {
            console.log('userInfo: ', data);

            // console.log(data);
            // this.sessionState = data.sessionState ? data.sessionState : null;
            this.showIndicator = false;
            // this.lastMsg = data;
            // this.sessionDetails = data.sessionDetails;
            this.types = [];
            // if (data.sessionDetails) {
            //   this.sessionAttrib = data.sessionDetails.sessionAttributes;
            //   // slotToElicit = data
            //   slotToElicit = data.sessionDetails.slotToElicit;
            // }

            // if (data.sessionState) {
            //   this.sessionAttrib = data.sessionState.sessionAttributes;
            //   // slotToElicit = data
            //   slotToElicit = data.sessionState.dialogAction.slotToElicit;
            // }
            // if (data.userInfo) {
            //   this.userDetails = data.userInfo;
            //   localStorage.setItem('phone', data.sessionState.intent.slots.phone.value.originalValue);
            //   localStorage.setItem('email', data.userInfo.email);
            //   localStorage.setItem('name', data.userInfo.name);
            //   // localStorage.setItem('phone', data.userInfo.phone);
            //   // localStorage.setItem('name', data.userInfo.name);
            //
            // } else {
            //   data.userInfo = this.userDetails;
            // }
            // this.lastMsg.showInput = true;
            // this.lastMsg.timestamp = new Date().getTime();
            this.formValue = '';
            // this.scroollProp.nativeElement.scrollIntoView({
            //   behavior: "smooth",
            //   block: "end",
            // });
            if (divId) {
              const el = document.getElementById(divId);
              const all = el ? el.getElementsByTagName('button') : null;
              if (all) {
                for (let i = 0; i < all.length; i++) {
                  all[i].className += ' btn-disabled';
                  all[i].disabled = false;
                }
              }
            }
          });
      // $("#content").scrollTop($("#content")[0].scrollHeight);
    }
    this.formValue = '';

    //  $("#content").scrollTop($("#content")[0].scrollHeight);
  }

  // scrollLast(last) {
  //   if (last) {
  //     this.scroollProp.nativeElement.scrollIntoView({
  //       behavior: "smooth",
  //       block: "end",
  //     });
  //   }
  // }

  addEmoji(event) {
    if (!this.formValue) {
      this.formValue = '';
    }
    this.formValue = this.formValue + event.emoji.native;
    $('#text').val($('#text').val() + event.emoji.native);
    this.showEmoj = !this.showEmoj;
  }

  switchEmoj() {
    this.showEmoj = !this.showEmoj;
    if (this.showEmoj === true) {
      $('.float-icon').css('z-index', '99');
    } else {
      console.log('open it ');
      $('.float-icon').css('z-index', '0');
    }
  }

  closeMessage() {
    $('.welcome-message-toggle').hide();
  }

  clearMessages(): void {
    this.chat.conversation.next([]);
    this.starRatingModuleTriggerCount = 0;
    this.initialClick = true;
    // this.welcomeMessage()
    // localStorage.clear()
    // this.sessionIdFn()
  }

  importFile(files: File[]) {
    // this.uploading = true;
    const file = files[0];
    const reader = new FileReader();
    if (
        file.type.indexOf('image/') !== -1 ||
        file.type.indexOf('application/pdf') !== -1 ||
        file.type.indexOf('application/msword') !== -1 ||
        file.type.indexOf('audio/mpeg') !== -1 ||
        file.type.indexOf('text/plain') !== -1 ||
        file.type.indexOf('video/mp4') !== -1
    ) {
      reader.onload = () => {
        const obj = {
          fileName: file.name.replace(/\s/g, ''),
          fileSize: file.size,
          fileType: file.type,
          mode: 'Put'
        };
        this.chat
            .getSignedUrlToUpload(obj)
            .subscribe((response: any) => {
              if (response && response.url) {
                this.chat
                    .uploadFile(`${response.url}`, file)
                    .subscribe((res: any) => {
                      // this.uploading = false;
                      if (!res) {
                        this.sendMessage(`attachment:${response.fileName}:${file.type}`, null, null, reader.result);
                        // this.inputValue = null;
                      }
                    });
              } else {
                // this.uploading = false;
              }
            });
      };
      reader.readAsDataURL(file);
    } else {
      // this._snackbarSerice.openFailureSnackBar(
      //     'File type does not supported.'
      // );
      // this.uploading = false;
    }
  }

  triggerRatingModuleFrom(component) {
    if (component === 'header-component' && this.starRatingModuleTriggerCount > 0 ) {
      // if(){
      this.clearMessages();
      this.toggleService.toggleChatbot(2);
      // }
    } else {
      this.starRatingModuleTriggerCount = + this.starRatingModuleTriggerCount + 1;
    }
  }

}
